import { useRemoteClientDelete } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const DeleteSession = async (id: string) => {
  const { getUnitId } = useLocalStorage()
  const { remoteClientDelete } = useRemoteClientDelete()
  const { showToast } = useToast()

  try {
    await remoteClientDelete('/aulas', id + `?idUnidade=${getUnitId()}`)
    showToast('Aula excluida com sucesso', 'success')
  } catch (error) {
    console.error({ error })
    showToast('Erro ao excluir aula', 'error')
  }
}
